// Shared FAQ data for use across the application
// Used by both the dedicated FAQ page and ProductDescriptionPage FAQ tab

const faqData = [
  {
    id: 1,
    question: "What material do you use in your jewelry?",
    answer: "We use premium-grade stainless steel for all our pieces — built to last, feel rich, and look fire. Every piece is anti-tarnish, water-resistant, and crafted for daily wear."
  },
  {
    id: 2,
    question: "Is your jewelry waterproof and sweatproof?",
    answer: "Yes. All AGNIR jewelry is waterproof, sweatproof, and anti-tarnish. Wear it in the shower, gym, or daily hustle — it stays bold, always. However, for longevity, we recommend avoiding prolonged exposure to saltwater, chlorine, and harsh chemicals."
  },
  {
    id: 3,
    question: "How do I find my ring or bracelet size?",
    answer: "You can refer to our Size Guide on the product page. We've got you covered with easy tips to measure at home using a reference video in the size chart option."
  },
  {
    id: 4,
    question: "How can I track my order?",
    answer: "Once your order is shipped, you'll get a tracking link via email or SMS. You can also reach out to us directly if you need any help with delivery updates."
  },
  {
    id: 5,
    question: "Do you provide warranty?",
    answer: "Yes. All AGNIR pieces come with a 6-month warranty against fading or rusting. If you face any issues, just contact us with proof — we'll take care of it."
  }
];

export default faqData;